import AuthAPI from './authInstance'

const getAll = async (params = {}) => {
  const response = await AuthAPI.get(`/admin/contact-support/list-contacts`, { params })
  return response.data
}

const getOne = async (data) => {
  const response = await AuthAPI.get(`/admin/contact-support/${data}`)
  return response.data
}

export const SupportService = {
  getAll,
  getOne,
}
